(function () {
  if (window.__newProductCardInit) return;
  window.__newProductCardInit = true;

  function setActiveSwatch(card, swatch) {
    card.querySelectorAll('[data-product-card-swatch]').forEach(function (btn) {
      btn.classList.remove('is--active');
      btn.setAttribute('aria-pressed', 'false');
    });
    swatch.classList.add('is--active');
    swatch.setAttribute('aria-pressed', 'true');
  }

  function updateCover(card, swatch, preserveLazy) {
    var cover = card.querySelector('[data-new-product-card-cover]');
    if (!cover) return;

    var src = swatch.getAttribute('data-image-src');
    var srcset = swatch.getAttribute('data-image-srcset');
    if (!src) return;

    cover.querySelectorAll('img').forEach(function (img) {
      if (preserveLazy) {
        var initialImage = new URL(img.getAttribute('src') || '', document.baseURI);
        var swatchImage = new URL(src, document.baseURI);
        if (initialImage.pathname === swatchImage.pathname && initialImage.searchParams.get('v') === swatchImage.searchParams.get('v')) return;
      }
      if (srcset) {
        img.srcset = srcset;
        img.setAttribute('srcset', srcset);
      } else {
        img.removeAttribute('srcset');
        img.srcset = '';
      }
      img.src = src;
      img.setAttribute('src', src);
      // Initial card setup must preserve native lazy loading below the fold.
      if (!preserveLazy) img.loading = 'eager';
      img.classList.remove('lazyloadt4s', 'lazyloadt4s--done');
    });

    cover.querySelectorAll('picture source').forEach(function (source) {
      if (srcset) {
        source.setAttribute('srcset', srcset);
      } else if (src) {
        source.setAttribute('srcset', src);
      }
    });
  }

  function syncAtcButton(card, variantId, activeSwatch) {
    var atcBtn = card.querySelector('[data-new-product-card-action]');
    if (!atcBtn) return;

    var isQuickAdd = atcBtn.hasAttribute('data-action-quickview');
    var textEl = atcBtn.querySelector('.atc-price-btn__text');
    var addLabel = isQuickAdd
      ? atcBtn.getAttribute('data-label-quick-add') || 'Quick Add'
      : atcBtn.getAttribute('data-label-add-to-cart') || 'Add to cart';
    var soldLabel = atcBtn.getAttribute('data-label-sold-out') || 'Sold out';
    var isSoldOut = activeSwatch && activeSwatch.classList.contains('is--soldout');
    var href = activeSwatch && activeSwatch.getAttribute('href');

    if (isQuickAdd) {
      if (href) atcBtn.setAttribute('href', href);
      if (variantId) atcBtn.setAttribute('data-id', variantId);
    } else if (variantId) {
      atcBtn.setAttribute('data-variant-id', variantId);
    }

    if (isSoldOut) {
      atcBtn.setAttribute('aria-disabled', 'true');
      atcBtn.setAttribute('aria-label', soldLabel);
      if (isQuickAdd) atcBtn.setAttribute('tabindex', '-1');
      else atcBtn.setAttribute('disabled', 'disabled');
      if (textEl) textEl.textContent = soldLabel;
      return;
    }

    atcBtn.removeAttribute('aria-disabled');
    atcBtn.removeAttribute('disabled');
    atcBtn.removeAttribute('tabindex');
    atcBtn.setAttribute('aria-label', addLabel);
    if (textEl) textEl.textContent = addLabel;
  }

  function syncCardLinks(card, swatch) {
    var href = swatch && swatch.getAttribute('href');
    if (!href) return;
    card.querySelectorAll('a.new-product-card__media-link, a.new-product-card__title-link').forEach(function (link) {
      link.setAttribute('href', href);
    });
  }

  function applySwatch(card, swatch, previewing, preserveLazy) {
    if (!card || !swatch) return;
    setActiveSwatch(card, swatch);
    updateCover(card, swatch, preserveLazy);
    syncAtcButton(card, swatch.getAttribute('data-variant-id'), swatch);
    syncCardLinks(card, swatch);
    if (typeof previewing !== 'boolean') {
      previewing = swatch.hasAttribute('data-default-swatch') === false;
    }
    card.classList.toggle('is--swatch-preview', previewing);
  }

  function defaultSwatch(card) {
    return card.querySelector('[data-product-card-swatch][data-default-swatch]') || card.querySelector('[data-product-card-swatch].is--active');
  }

  function restoreCard(card) {
    if (!card) return;
    var swatch = defaultSwatch(card);
    card.__previewSwatch = swatch || null;
    if (swatch) applySwatch(card, swatch, false);
    else card.classList.remove('is--swatch-preview');
  }

  function initCardCovers(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var cards = root && root.matches && root.matches('.new-product-card') ? [root] : scope.querySelectorAll('.new-product-card');
    cards.forEach(function (card) {
      var active = card.querySelector('[data-product-card-swatch].is--active');
      if (active) applySwatch(card, active, undefined, true);
    });
  }

  var mobileSwatchQuery = window.matchMedia('(max-width: 767px)');

  function isMobileSwatch() {
    return mobileSwatchQuery.matches;
  }

  function persistSwatch(card, swatch) {
    card.querySelectorAll('[data-product-card-swatch][data-default-swatch]').forEach(function (el) {
      el.removeAttribute('data-default-swatch');
    });
    swatch.setAttribute('data-default-swatch', '');
    card.__previewSwatch = swatch;
    applySwatch(card, swatch, false);
  }

  function onSwatchClick(event) {
    if (!isMobileSwatch()) return;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var swatch = event.target.closest && event.target.closest('[data-product-card-swatch]');
    if (!swatch) return;
    event.preventDefault();
    var card = swatch.closest('.new-product-card');
    if (!card) return;
    persistSwatch(card, swatch);
  }

  function onSwatchOver(event) {
    if (isMobileSwatch()) return;
    var swatch = event.target.closest && event.target.closest('[data-product-card-swatch]');
    if (!swatch) return;
    var card = swatch.closest('.new-product-card');
    if (!card) return;
    if (card.__previewSwatch === swatch) return;
    card.__previewSwatch = swatch;
    applySwatch(card, swatch, true);
  }

  function onCardOut(event) {
    if (isMobileSwatch()) return;
    var card = event.target.closest && event.target.closest('.new-product-card');
    if (!card || !card.__previewSwatch) return;
    var related = event.relatedTarget;
    if (related && card.contains(related)) return;
    restoreCard(card);
  }

  document.addEventListener('click', onSwatchClick, true);
  document.addEventListener('mouseover', onSwatchOver, true);
  document.addEventListener('mouseout', onCardOut, true);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initCardCovers();
    });
  } else {
    initCardCovers();
  }

  window.drexeyInitProductCardCovers = initCardCovers;
})();
